import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../services/auth.service';
import {FormGroup, FormControl, Validators} from '@angular/forms';


@Component({
    selector: 'app-modal-definir-conta',
    templateUrl: './modal-definir-conta.component.html',
    styleUrls: ['./modal-definir-conta.component.scss']
})


export class ModalDefinirContaComponent implements OnInit {

    @Output() contaEscolhida = new EventEmitter<string>();
    permissoes = '';

    constructor(private modalService: NgbModal, public activeModal: NgbActiveModal, private http: HttpClient) {
    }

    ngOnInit() {
    }

    definirConta(conta: string) {
       this.contaEscolhida.emit(conta);
       this.permissoes = conta;
    }
}

